import React, {  useState } from 'react';
import { Form as BootstrapForm } from 'react-bootstrap';
import { Formik, Form } from 'formik';

import ClearIcon from '@material-ui/icons/Clear';
import DoneIcon from '@material-ui/icons/Done';

import * as Yup from 'yup';

import { ExistingEmailErrorModal } from '../ExistingEmailErrorModal';
import { useDispatch } from 'react-redux';
import { useSelector } from "react-redux";
import { SuccessModal } from '../SuccessModal';

import api from '~/services/api';

import {
  LoginTitle,
  LoginSubTitle,
  ConfirmationContainer,
  SignInButton,
  DivField,
  ErrorMessage,
  StyledInput,
} from './styles';

export function NewPassword() {
  const [isModalEmailError, setIsModalEmailError] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  
  const dispatch = useDispatch();
  const codeToken = useSelector((state) => state.tokenReducer.codeToken)
  const reducerUserId = useSelector((state) => state.stepsReducer.reducerUserId)
  
  const SigninSchema = Yup.object().shape({
    password: Yup.string()
      .required('Preencha sua senha')
      .min(10, 'Mínimo de 10 caracteres')
      .matches(/[A-Z]/, 'No mínimo uma letra maiúscula')
      .matches(/[a-z]/, 'No mínimo uma letra minúscula')
      .matches(/[0-9]/, 'No mínimo um número')
      .matches(/[!@#$%^&*(),.?":{}|<>]/, 'No mínimo um caractere especial (&%$#@)'),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref('password'), null], 'As senhas devem corresponder')
      .required('Confirme sua nova senha'),
  });

  const hasValidationError = (value, regex) => !value.match(regex);

  const areAllConditionsMet = (values) => {
    return (
      !hasValidationError(values.password, /.{10}/) &&
      !hasValidationError(values.password, /[A-Z]/) &&
      !hasValidationError(values.password, /[a-z]/) &&
      !hasValidationError(values.password, /[0-9]/) &&
      !hasValidationError(values.password, /[!@#$%^&*(),.?":{}|<>]/) &&
      values.password === values.confirmPassword &&
      values.password !== '' &&
      values.confirmPassword !== ''
    );
  };

  async function updateUserPasswordWithToken(values) {
    const sessionToken = localStorage.getItem('reset_password_session_token');
    const email = localStorage.getItem('email');

    if (!sessionToken) {
      dispatch({ type: "SET_STEP", step: 60 });
      return;
    }

    const header = {
      'Content-Type': 'application/json',
      'Accept-Language': 'pt-BR',
      'X-Reset-Password-Session-Token': sessionToken,
      client_id: process.env.REACT_APP_CLIENT_ID,
    };

    const parameters = {
      method: 'POST',
      headers: header,
    };

    const body = {
      email: email,
      password: values.password,
      passwordConfirmation: values.confirmPassword,
      token: codeToken
    };

    try {
      await api.post(`residential/store/v1/users/reset-password-confirm`, body, parameters);
      localStorage.removeItem('reset_password_session_token');
      setIsModalOpen(true);
    } catch (error) {
      if(error.response && error.response.data && error.response.data.code === '422.030') {
        setIsModalEmailError(true);
      } else {
        dispatch({ type: "SET_STEP", step: 60 });
      }
    }
  }
  
  return (
    <>
      {isModalEmailError && <ExistingEmailErrorModal isModalEmailError={isModalEmailError} handleCloseEmailError={() => setIsModalEmailError(false)} /> }
      {isModalOpen &&  <SuccessModal isModalOpen={isModalOpen} handleClose={() => setIsModalOpen(false)} /> }
      <LoginTitle className="mb-3">Cadastre sua nova senha:</LoginTitle>
      <Formik
        initialValues={{ password: '', confirmPassword: '' }}
        onSubmit={async values => {
          await requestSignIn(values);
        }}
        validationSchema={SigninSchema}
      >
        {({ handleChange, handleBlur, values, errors, touched }) => (
          <Form style={{ width: '100%' }} autoComplete="off">
            <BootstrapForm style={{ width: '100%' }} autoComplete="off">
              <BootstrapForm.Group controlId="password">
                <DivField errorCondition={errors.password && touched.password}>
                  <StyledInput
                    id="password"
                    type={'password'}
                    arial-label="Senha"
                    aria-required
                    title="Senha"
                    onBlur={handleBlur}
                    placeholder="Escreva sua nova senha"
                    value={values.password}
                    onChange={e => {
                      handleChange(e);
                    }}
                  />
                </DivField>
                {errors.password && touched.password ? (
                  <ErrorMessage>A senha não preenche os requisitos de segurança. <br />Insira outra senha.</ErrorMessage>
                ) : null}
              </BootstrapForm.Group>
              <BootstrapForm.Group controlId="confirmPassword">
                <DivField>
                  <StyledInput
                    id="confirmPassword"
                    type={'password'}
                    arial-label="Confirme a senha"
                    aria-required
                    title="Confirme a senha"
                    onBlur={handleBlur}
                    placeholder="Confirme a nova senha"
                    value={values.confirmPassword}
                    onChange={e => {
                      handleChange(e);
                    }}
                  />
                </DivField>
              </BootstrapForm.Group>
            </BootstrapForm>
            <LoginSubTitle style={{ color: '#000FFF' }} className="mb-10">Atenção! A senha cadastrada deverá ter:</LoginSubTitle>
            <ConfirmationContainer className="mb-0" style={{ color: hasValidationError(values.password, /.{10}/) ? 'red' : 'black' }}>
              No mínimo 10 caracteres
              {hasValidationError(values.password, /.{10}/) ? <ClearIcon style={{ color: 'red', marginLeft: 2, fontSize: '18px' }} /> : <DoneIcon style={{ color: '#000FFF', marginLeft: 2, fontSize: '18px' }} />}
            </ConfirmationContainer>
            <ConfirmationContainer className="mb-0" style={{ color: hasValidationError(values.password, /[A-Z]/) ? 'red' : 'black' }}>
              No mínimo uma letra maiúscula
              {hasValidationError(values.password, /[A-Z]/) ? <ClearIcon style={{ color: 'red', marginLeft: 2, fontSize: '18px' }} /> : <DoneIcon style={{ color: '#000FFF', marginLeft: 2, fontSize: '18px' }} />}
            </ConfirmationContainer>
            <ConfirmationContainer className="mb-0" style={{ color: hasValidationError(values.password, /[a-z]/) ? 'red' : 'black' }}>
              No mínimo uma letra minúscula
              {hasValidationError(values.password, /[a-z]/) ? <ClearIcon style={{ color: 'red', marginLeft: 2, fontSize: '18px' }} /> : <DoneIcon style={{ color: '#000FFF', marginLeft: 2, fontSize: '18px' }} />}
            </ConfirmationContainer>
            <ConfirmationContainer className="mb-0" style={{ color: hasValidationError(values.password, /[0-9]/) ? 'red' : 'black' }}>
              No mínimo um número
              {hasValidationError(values.password, /[0-9]/) ? <ClearIcon style={{ color: 'red', marginLeft: 2, fontSize: '18px' }} /> : <DoneIcon style={{ color: '#000FFF', marginLeft: 2, fontSize: '18px' }} />}
            </ConfirmationContainer>
            <ConfirmationContainer className="mb-0" style={{ color: hasValidationError(values.password, /[!@#$%^&*(),.?":{}|<>]/) ? 'red' : 'black' }}>
              No mínimo um caractere especial (%#@)
              {hasValidationError(values.password, /[!@#$%^&*(),.?":{}|<>]/) ? <ClearIcon style={{ color: 'red', marginLeft: 2, fontSize: '18px' }} /> : <DoneIcon style={{ color: '#000FFF', marginLeft: 2, fontSize: '18px' }} />}
            </ConfirmationContainer>
            <ConfirmationContainer className="mb-0" style={{ color: (values.password !== values.confirmPassword || values.confirmPassword === '') ? 'red' : 'black' }}>
              As senhas devem corresponder
              {(values.password !== values.confirmPassword || values.confirmPassword === '') ? <ClearIcon style={{ color: 'red', marginLeft: 2, fontSize: '18px' }} /> : <DoneIcon style={{ color: '#000FFF', marginLeft: 2, fontSize: '18px' }} />}
            </ConfirmationContainer>
            <SignInButton
              type="submit"
              className="mt-4"
              disabled={!areAllConditionsMet(values)}
              onClick={()=>{
                updateUserPasswordWithToken(values)
              }}
              style={{
                backgroundColor: (!areAllConditionsMet(values)) ? 'gray' : '#000FFF',
              }}
            >
             <span>Confirme sua nova senha</span>
            </SignInButton>
          </Form>
        )}
      </Formik>
    </>
  );
}
